import React, { useState } from "react";
import Modal from "../../../components/ui/Modal";
import Button from "../../../components/ui/Button";

const TicketDetailModal = ({ ticket, isOpen, onClose, onReply }) => {
  const [replyMessage, setReplyMessage] = useState("");

  if (!ticket) return null;

  const handleSendReply = () => {
    if (!replyMessage.trim()) return;
    onReply(ticket.id, replyMessage);
    setReplyMessage("");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Ticket #${ticket.id}: ${ticket.subject}`}
    >
      <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
        {ticket.conversation.map((msg, index) => (
          <div
            key={index}
            className={`p-3 rounded-lg ${
              msg.from === "Adnaki Support" ? "bg-primary/10" : "bg-slate-100"
            }`}
          >
            <p className="font-semibold text-sm text-slate-800">{msg.from}</p>
            <p className="text-sm text-slate-600 mt-1">{msg.message}</p>
          </div>
        ))}
      </div>
      <div className="mt-6">
        <textarea
          rows="4"
          placeholder="Type your reply here..."
          className="w-full p-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary focus:outline-none"
          value={replyMessage}
          onChange={(e) => setReplyMessage(e.target.value)}
        />
        <div className="flex justify-end mt-2">
          <Button variant="primary" onClick={handleSendReply}>
            Send Reply
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TicketDetailModal;
